var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41421,
    viewBox: "0 0 68 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 27.66h30v28h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875 1789.29c0-4.6 2.193-27.95 29.76-27.95v13.75s-14.68.24-14.68 14.2",
    transform: "translate(-875 -1761.34)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38 27.66h30v28h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875 1789.29c0-4.6 2.193-27.95 29.76-27.95v13.75s-14.68.24-14.68 14.2",
    transform: "translate(-837 -1761.34)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quote.48ca94ce.svg";
export { ForwardRef as ReactComponent };